import { render, staticRenderFns } from "./LayoutChoose.vue?vue&type=template&id=45aee804&scoped=true&"
import script from "./LayoutChoose.vue?vue&type=script&lang=js&"
export * from "./LayoutChoose.vue?vue&type=script&lang=js&"
import style0 from "./LayoutChoose.vue?vue&type=style&index=0&id=45aee804&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aee804",
  null
  
)

export default component.exports